import { render, staticRenderFns } from "./workerIdCard.vue?vue&type=template&id=74a79a14&scoped=true&"
import script from "./workerIdCard.vue?vue&type=script&lang=js&"
export * from "./workerIdCard.vue?vue&type=script&lang=js&"
import style0 from "./workerIdCard.vue?vue&type=style&index=0&id=74a79a14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a79a14",
  null
  
)

export default component.exports